import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type RequestMagicLinkRequestBody = {
  email: string;
  redirect_url?: string;
};

export const requestMagicLink = async ({ body }: BodyRequest<RequestMagicLinkRequestBody>) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.oauth.magicLink, body, { skipAuth: true });
